module.exports = __webpack_public_path__ + "img/bike_station_disabled.45feb0c7.svg";